import { isEmpty } from 'core/packages/utils';

import { parseExperienceToModel } from './experience';
import { parseTriperToModel } from './triper';

export const parseTripExperienceToModel = (tripExperience) => ({
    id: tripExperience?.id,
    from: tripExperience?.from,
    to: tripExperience?.to,
    proposedBy: !isEmpty(tripExperience?.proposedBy)
        ? parseTriperToModel(tripExperience?.proposedBy)
        : [],
    experience: parseExperienceToModel(tripExperience?.experience),
});

export const parseTripExperienceToObject = (data) => ({
    ...data,
});
